export function getCurrentUrl(pathname: string) {
	return pathname.split(/[?#]/)[0];
}

export function checkIsActive(pathname: string, url: string) {
	const current = getCurrentUrl(pathname);
	if (!current || !url) {
		return false;
	}

	if (current === url) {
		return true;
	}

	// checking this way to ensure team ID of 8 doesn't show active when team ID
	// 87 is selected
	const regex = new RegExp(`^${url}\/`);
	return regex.test(current);
}
